import { render, staticRenderFns } from "./artistDetail.vue?vue&type=template&id=0f19adec&scoped=true&"
import script from "./artistDetail.vue?vue&type=script&lang=js&"
export * from "./artistDetail.vue?vue&type=script&lang=js&"
import style0 from "./artistDetail.vue?vue&type=style&index=0&id=0f19adec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f19adec",
  null
  
)

export default component.exports